export const paths = {
  budget: '/budget/:budgetId',
  budgetCalculation: '/budget/:budgetId/calculation',
  budgetDashboard: '/budget/:budgetId/dashboard',
  budgetDivisionCalendar: '/budget/:budgetId/divisions/calendar',
  budgetDivisions: '/budget/:budgetId/divisions',
  budgetItemsImport: '/budget/:budgetId/items/import',
  budgetSummary: '/budget/:budgetId/summary',
  budgetListini: '/budget/:budgetId/listini',
  divisionCostsImport: '/budget/:budgetId/division-costs',
  energyCostsImport: '/budget/:budgetId/energy-costs',
  fixedCostsImport: '/budget/:budgetId/fixed-costs',
  homepage: '/',
  indirectMaterialImport: '/budget/:budgetId/indirect-material',
  login: '/login',
  needsGeneration: '/budget/:budgetId/needs-generation',
  noMatch: '*',
  productionVolumesImport: '/budget/:budgetId/production-volumes',
  productionConsumptionsImport: '/budget/:budgetId/production-consumptions',
  budgetResultItemPriceList: '/budget/:budgetId/item-price-list',
  stopTemplatesPage: '/general/stop-templates',
} as const

export const path = <P extends typeof paths[keyof typeof paths]>(p: P) => p
